(function (app) {
    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Root.Policies.Detail", {
            url: "/{MappedPolicyId}/Detail?accessToken&displayName",
            component: "policyDetail",
            params: {
                fadeFromRight: null
            },
            resolve: {
                policy: ["$transition$", "dataFeedApi", "accessTokenService", "fullStoryService", function ($transition$, dataFeedApi, accessTokenService, fullStoryService) {
                    var params = $transition$.params();
                    var hasAccess = false;
                    if (accessTokenService.getAccessToken()) {
                        hasAccess = true;
                    } else if (params.accessToken) {
                        accessTokenService.setAccessToken(params.accessToken);
                        hasAccess = true;
                    }
                    if (params.displayName) {
                        console.log(window.tempFS = fullStoryService);
                        fullStoryService.setUserVars({ displayName: params.displayName });
                    }
                    if (hasAccess === true) {
                        return dataFeedApi.getPolicyDetails(params.MappedPolicyId);
                    } else {
                        return null;
                    }
                }]
            }
        });
    }]);
    
    app.component("policyDetail", {
        templateUrl: "/App/States/Policies/Detail/detail.html",
        controller: detailController,
        bindings: {
            policy: "<"
        }
    });

    detailController.$inject = ["$stateParams", "dataFeedApi", "$anchorScroll", "$location", "searchService", "$state", "RequirementStatusOrder", "accessTokenService", "processorTrackApi"];
    function detailController($stateParams, dataFeedApi, $anchorScroll, $location, searchService, $state, RequirementStatusOrder, accessTokenService, processorTrackApi) {
        let $ctrl = this;
        $location.hash("detailContent");
        $anchorScroll();
        $ctrl.animation = $stateParams.fadeFromRight;
        $ctrl.scrollTo = function(element) {
            $ctrl.pulse = element;
            $location.hash(element);
            $anchorScroll();
        };
        $ctrl.policyId = $stateParams.MappedPolicyId;

        $ctrl.backToPolicies = function () {
            $state.go("Root.Policies.List", { search: searchService.getTerm() || null });
        };

        if (accessTokenService.hasAdminAccess()) {
            $ctrl.isAdmin = true;
        }

        $ctrl.$onInit = () => {
            if ($ctrl.policy) {
                $ctrl.loading = true;
                let statuses = RequirementStatusOrder;
                let orderedRequirements = [];
                statuses.forEach(status => {
                    let requirements = $ctrl.policy.Requirements.filter(requirement => {
                        return requirement.Status === status;
                    });
                    requirements.sort((a, b) => {
                        return new Date(b.RequestedOn) - new Date(a.RequestedOn);
                    });
                    orderedRequirements = orderedRequirements.concat(requirements);
                });
                let other = $ctrl.policy.Requirements.filter(requirement => {
                    return !statuses.includes(requirement.Status);
                });
                other.sort((a, b) => {
                    return new Date(b.RequestedOn) - new Date(a.RequestedOn);
                });
                $ctrl.policy.Requirements = orderedRequirements.concat(other);
                $ctrl.getDataSourceEntityName();
                $ctrl.loading = false;
            }
        };

        $ctrl.getDataSourceEntityName = () => {
            return processorTrackApi.getDataSourceEntityName($ctrl.policy.Policy.FileProcessorTrackId).then(
                function(name) {
                    $ctrl.dataSourceEntityName = name;
                });
        };

        //
        // Details on how this framework is laid out. There are five 
        // properties that will be used on an accessor object. They are
        // display, key, format, args, and switchOn.
        // 
        // display - Is only needed if the display needs to vary from the key.
        //          i.e. -> { key: "Name" } will result in "Name" on the UI
        //               -> { display: "Full Name", key: "Name" } will result in "Full Name"
        // key - the property key of the property on the targeted data source
        // format - can be a built in angularjs filter or a custom one
        // args - arguments that will be passed to a filter
        // switchOn - some cards combine two models into one targeted data source
        //            RelatedParties is an example of this.
        //

        $ctrl.togglers = [
            { display: "Agents", key: "Agents", expanded: true, disabled: false },
            { display: "Carrier Notes", key: "CarrierNotes", expanded: true, disabled: false },
            { display: "Carrier", key: "Carrier", expanded: true, disabled: false },
            { display: "Financial Transactions", key: "FinancialTransactions", expanded: false, disabled: false },
            { display: "Fund Allocations", key: "FundAllocations", expanded: false, disabled: false },
            { display: "Fundings", key: "Fundings", expanded: true, disabled: false },
            { display: "Inforce Financial Trans.", key: "InforceFinancialTransactions", expanded: false, disabled: false },
            { display: "Policy", key: "Policy", expanded: true, disabled: false },
            { display: "Policy Stages", key: "PolicyStages", expanded: true, disabled: false },
            { display: "Policy Values", key: "PolicyValues", expanded: true, disabled: false },
            { display: "Policy Percentages", key: "PolicyPercentages", expanded: true, disabled: false },
            { display: "Product", key: "Product", expanded: true, disabled: false },
            { display: "Related Parties", key: "RelatedParties", expanded: true, disabled: false },
            { display: "Requirements", key: "Requirements", expanded: true, disabled: false },
            { display: "Service Features", key: "ServiceFeatures", expanded: false, disabled: false },
            { display: "Uplines", key: "Uplines", expanded: true, disabled: false }
        ];

        $ctrl.policyDetails = [
            { display: "Data Received On", key: "ModifiedOn", format: "cardDateTime", class: "bolder" },
            { display: "Last Updated by Carrier", key: "LastUpdatedOn", format: "cardDate", class: "bolder" },
            { display: "Policy Number", key: "PolicyNumber", valueClass: "fs-block" },
            { key: "Jurisdiction" },
            { display: "Tax Qualification", key: "TaxQualification" },
            { display: "Tax Qualification Type", key: "TaxQualificationType" },
            { display: "Current Status", key: "CurrentStatus" },
            { display: "Suitability Review Status", key: "SuitabilityReviewStatus" },
            { display: "Issue On", key: "IssueOn" },
            { display: "Face Amount", key: "FaceAmount", format: "filterFactory", args: "currency" },
            { display: "Target Premium", key: "TargetPremium", format: "filterFactory", args: "currency" },
            { display: "Initial Interest Rate", key: "InitialInterestRate" },
            { display: "Guaranteed Rate", key: "GuaranteedRate" },
            { display: "Guaranteed Period", key: "GuaranteedPeriod" },
            { display: "Submission Type", key: "SubmissionType" },
            { display: "Health Class", key: "HealthClass" },
            { display: "Tobacco Status", key: "TobaccoStatus" },
            { display: "Replacement Type", key: "ReplacementType" },
            { display: "Payment Mode", key: "PaymentMode" },
            { display: "Premium Balance Due", key: "PremiumBalanceDue", format: "filterFactory", args: "currency" },
            { display: "Lives Type", key: "LivesType" },
            { display: "New Business Contact", key: "NewBusinessContactName", valueClass: "fs-block" },
            { display: "Home Office Underwriter", key: "HomeOfficeUnderwriterName", valueClass: "fs-block" },
            { display: "Replacement Indicator", key: "ReplacementIndicator" },
            { display: "Mec Indicator", key: "MecIndicator" },
            { display: "Issue Age", key: "IssueAge" },
            { display: "Billing Form", key: "BillingForm" },
            { display: "Billing Day", key: "BillingDay" },
            { display: "Delivery State", key: "DeliveryState" }
        ];

        $ctrl.policyCarrier = [
            { key: "Name" },
            { display: "Carrier Codes", key: "CarrierCodes", format: "arrayData" },
            { key: "Tins", format: "arrayData" },
            { key: "Feins", format: "arrayData" }
        ];

        $ctrl.policyProducts = [
            { key: "Name" },
            { display: "Product Id", key: "ProductId" },
            { key: "Cusip" },
            { display: "Product Type", key: "ProductType" },
            { display: "Line Of Business", key: "LineOfBusiness" },
            { display: "Surrender Period", key: "SurrenderPeriod" }
        ];

        $ctrl.policyAgents = [
            { key: "Name", valueClass: "fs-block" },
            { key: "Relationships", format: "arrayData" },
            { key: "CommissionPercentage", format: "percentage" }
        ];

        $ctrl.policyAgents.subSelectors = [
            { display: "Primary", key: "IsPrimary" },
            { display: "Commission Option", key: "CommissionOption" },
            { display: "Writing Numbers", key: "WritingNumbers", format: "arrayData", valueClass: "fs-block" },
            { display: "Brokers Agent Id", key: "BrokersAgentId", valueClass: "fs-block" },
            { key: "Dob", format: "cardDate", valueClass: "fs-block" },
            { key: "Ssn", valueClass: "fs-block" },
            { display: "Ssn Last Four", key: "SsnLastFour", valueClass: "fs-block" },
            { key: "Npn", valueClass: "fs-block" },
            { key: "Gender" },
            { display: "Phone Numbers", key: "PhoneNumbers", format: "arrayData", valueClass: "fs-block" },
            { display: "Email Addresses", key: "EmailAddresses", format: "arrayData", valueClass: "fs-block" },
            { display: "Physical Addresses", key: "PhysicalAddresses", format: "arrayData", args: ["AddressLineOne", "AddressLineTwo", "AddressLineThree", "City", "State", "Zip"], valueClass: "fs-block" }
        ];

        $ctrl.policyUplines = [
            { key: "Name", valueClass: "fs-block" },
            { key: "Relationships", format: "arrayData" },
            { display: "Writing Numbers", key: "WritingNumbers", format: "arrayData", valueClass: "fs-block" }
        ];

        $ctrl.policyUplines.subSelectors = [
            { key: "Tin", valueClass: "fs-block" },
            { display: "Tin Last Four", key: "TinLastFour", valueClass: "fs-block" },
            { display: "Phone Numbers", key: "PhoneNumbers", format: "arrayData", valueClass: "fs-block" },
            { display: "Email Addresses", key: "EmailAddresses", format: "arrayData", valueClass: "fs-block" },
            { display: "Physical Addressess", key: "PhysicalAddresses", format: "arrayData", args: ["AddressLineOne", "AddressLineTwo", "AddressLineThree", "City", "State", "Zip"], valueClass: "fs-block" }
        ];

        $ctrl.relatedParties = [
            { key: "Name", valueClass: "fs-block" },
            { key: "Relationships", format: "arrayData" }
        ];

        $ctrl.relatedParties.subSelectors = [
            { display: "Relationship To Owner", key: "RelationshipToOwner" },
            { display: "Beneficiary Type", key: "BeneficiaryType" },
            { display: "Beneficiary %", key: "BeneficiaryDesignationPercentage", format: "percentage" },

            // related person specific
            { key: "Dob", format: "cardDate", switchOn: "TransientMappedPersonId", valueClass: "fs-block" },
            { key: "Ssn", switchOn: "TransientMappedPersonId", valueClass: "fs-block" },
            { display: "Ssn Last Four", key: "SsnLastFour", switchOn: "TransientMappedPersonId", valueClass: "fs-block" },
            { key: "Npn", switchOn: "TransientMappedPersonId", valueClass: "fs-block"},
            { key: "Gender", switchOn: "TransientMappedPersonId" },
            // end -------------------

            // related entity specific
            { key: "Tin", switchOn: "TransientMappedEntityId", valueClass: "fs-block" },
            { display: "Tin Last Four", key: "TinLastFour", switchOn: "TransientMappedEntityId", valueClass: "fs-block" },
            { display: "Trust Date", key: "TrustDate", format: "cardDate", switchOn: "TransientMappedEntityId", valueClass: "fs-block" },
            // end -------------------

            { display: "Phone Numbers", key: "PhoneNumbers", format: "arrayData", valueClass: "fs-block" },
            { display: "Email Addresses", key: "EmailAddresses", format: "arrayData", valueClass: "fs-block" },
            { display: "Physical Addresses", key: "PhysicalAddresses", format: "arrayData", args: ["AddressLineOne", "AddressLineTwo", "AddressLineThree", "City", "State", "Zip"], valueClass: "fs-block" },
            { display: "Annuitization Payouts", key: "AnnuitizationPayouts", format: "modal"}
        ];

        $ctrl.policyCarrierNotes = [
            { display: "Date Added", key: "DateAdded", format: "cardDate", class: "thin-column" },
            { key: "Note", valueClass: "fs-block" }
        ];

        $ctrl.policyRequirements = [
            { key: "Title", class: "medium-column"  },
            { key: "Description", valueClass: "fs-block" },
            { key: "Status", class: "thin-column" },
            { display: "Requested On", key: "RequestedOn", format: "cardDate", class: "thin-column" },
            { display: "Received On", key: "ReceivedOn", format: "cardDate", class: "thin-column" },
            { key: "Notes", valueClass: "fs-block" }
        ];

        $ctrl.policyRequirements.subSelectors = [
            { key: "Identifier", valueClass: "fs-block" },
            { display: "Reviewed On", key: "ReviewedOn", format: "cardDate" },
            { display: "Due On", key: "DueOn", format: "cardDate" },
            { display: "Fulfilled On", key: "FulfilledOn", format: "cardDate" },
            { display: "Status Date", key: "StatusDate", format: "cardDate" }
        ];

        $ctrl.policyValuesSelectors = [
            { key: "PolicyValueType" },
            { key: "Amount", format: "filterFactory", args: "currency", valueClass: "fs-block" }
        ];

        $ctrl.policyPercentagesSelectors = [
            { key: "PolicyPercentageType" },
            { key: "Percentage", format: "percentage", valueClass: "fs-block" }
        ];

        $ctrl.getPolicyValuesQuery = () => {
            return dataFeedApi.getPolicyValues($stateParams.MappedPolicyId);
        };

        $ctrl.getPolicyPercentagesQuery = () => {
            return dataFeedApi.getPolicyPercentages($stateParams.MappedPolicyId);
        };

        $ctrl.policyStagesSelectors = [
            { key: "PolicyStageType" },
            { key: "Date", format: "cardDate" }
        ];

        $ctrl.getPolicyStagesQuery = () => {
            return dataFeedApi.getPolicyStages($stateParams.MappedPolicyId);
        };

        $ctrl.fundingSelectors = [
            { display: "Tax Qual", key: "TaxQualification" },
            { display: "Source", key: "FundingSource", valueClass: "fs-block" },
            { display: "Method", key: "FundingMethod" },
            { display: "Estimated Amount", key: "EstimatedAmount", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Issued Amount", key: "IssuedAmount", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Transfer Company", key: "TransferCompany", valueClass: "fs-block" }
        ];

        $ctrl.fundingSelectors.subSelectors = [
            { display: "Transfer Account Number", key: "TransferAccountNumber", valueClass: "fs-block" },
            { display: "Billing Method", key: "BillingMethod" },
            { display: "Billing Amount", key: "BillingAmount", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Received Amount", key: "ReceivedAmount", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "PhoneNumber", key: "PhoneNumber", valueClass: "fs-block" },
            { display: "Policy Number", key: "PolicyNumber", valueClass: "fs-block" },
            { display: "Liquidation Type", key: "LiquidationType" },
            { display: "Check Number", key: "CheckNumber", valueClass: "fs-block" },
            { display: "Mailed On", key: "MailedOn", format: "cardDate" },
            { display: "Received On", key: "ReceivedOn", format: "cardDate" },
            { display: "Notes Added On", key: "NotesAddedOn", format: "cardDate" },
            { key: "Notes", valueClass: "fs-block" },
            { key: "Frequency" },
            { display: "Premium Basis", key: "PremiumBasis", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Premium Bonus", key: "PremiumBonus", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Premium Income", key: "PremiumIncome", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Tax Year", key: "TaxYear", valueClass: "fs-block" },
            { display: "Total Amount", key: "TotalAmount", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Physical Addressess", key: "PhysicalAddresses", format: "arrayData", args: ["AddressLineOne", "AddressLineTwo", "AddressLineThree", "City", "State", "Zip"], valueClass: "fs-block" }
        ];

        $ctrl.getFundingsQuery = () => {
            return dataFeedApi.getFundings($stateParams.MappedPolicyId);
        };

        $ctrl.fundAllocationSelectors = [
            { key: "Name" },
            { display: "Total Value", key: "TotalValue", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Valuation Date", key: "ValuationAsOfDate", format: "cardDate" },
            { display: "Fund Value", key: "FundValue", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Fund %", key: "FundPercentage", format: "percentage", valueClass: "fs-block" },
            { display: "Value %", key: "FundValuePercentage", format: "percentage", valueClass: "fs-block" },
            { display: "Fund Units", key: "FundUnits", valueClass: "fs-block" }
        ];

        $ctrl.fundAllocationsQuery = () => {
            return dataFeedApi.getFundAllocations($stateParams.MappedPolicyId);
        };

        $ctrl.inforceFinancialTransactionSelectors = [
            { display: "Event Period Type", key: "EventPeriodType" },
            { display: "Event Total Amount", key: "EventTotalAmount", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Event Type Code", key: "EventTypeCode" },
            { display: "Gross/Net", key: "GrossNetIndictator", valueClass: "fs-block" },
            { display: "Next Event Date", key: "NextEventDate", format: "cardDate", valueClass: "fs-block" }
        ];

        $ctrl.getInforceFinancialTransactionsQuery = () => {
            return dataFeedApi.getInforceFinancialTransactions($stateParams.MappedPolicyId);
        };

        $ctrl.serviceFeatureSelectors = [
            { key: "Name" },
            { display: "Product Code", key: "ProductCode", valueClass: "fs-block" },
            { key: "Value", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Value Type", key: "ValueType" },
            { key: "Frequency" },
            { key: "Category" }
        ];

        $ctrl.serviceFeatureSelectors.subSelectors = [
            { display: "Start Date", key: "StartDate", format: "cardDate" },
            { display: "Stop Date", key: "StopDate", format: "cardDate" },
            { display: "Lives Type", key: "LivesType" },
            { display: "Current Number Of Units", key: "CurrentNumberOfUnits", valueClass: "fs-block" },
            { display: "Service Feature Types", key: "ServiceFeatureTypes", format: "arrayPair", args: ["TypeCode", "SubTypeCode"] }
        ];

        $ctrl.getServiceFeaturesQuery = () => {
            return dataFeedApi.getServiceFeatures($stateParams.MappedPolicyId);
        };

        $ctrl.financialTransactionSelectors = [
            { display: "Amount", key: "TransactionAmount", format: "filterFactory", args: "currency", valueClass: "fs-block" },
            { display: "Identifier", key: "TransactionIdentifier", valueClass: "fs-block" },
            { display: "Source Indicator", key: "TransactionSourceIndicator", valueClass: "fs-block" },
            { display: "Payment Type", key: "TransactionPaymentType", valueClass: "fs-block" },
            { display: "Effective Date", key: "TransactionDateEffective", format: "cardDate" },
            { display: "Process Date", key: "TransactionDateProcess", format: "cardDate" }
        ];

        $ctrl.getFinancialTransactionsQuery = () => {
            return dataFeedApi.getFinancialTransactions($stateParams.MappedPolicyId);
        };

        //
        // Some info cards require that additional data be queried in
        // Below are the corresponding queries.
        //

        // Additional Agent Info
        $ctrl.agentAdditionalQuery = (agent) => {
            return dataFeedApi.getAgentAdditional($stateParams.MappedPolicyId, agent.TransientMappedPersonId);
        };

        // Additional Upline Info
        $ctrl.uplineAdditionalQuery = (upline) => {
            return dataFeedApi.getUplineAdditional($stateParams.MappedPolicyId, upline.TransientMappedEntityId);
        };

        // Additional Related Party
        $ctrl.relatedPartyAdditionalQuery = (relatedParty) => {
            if (relatedParty.TransientMappedPersonId) {
                return dataFeedApi.getRelatedPeopleAdditional($stateParams.MappedPolicyId, relatedParty.TransientMappedPersonId);
            } else if (relatedParty.TransientMappedEntityId) {
                return dataFeedApi.getRelatedEntitiesAdditional($stateParams.MappedPolicyId, relatedParty.TransientMappedEntityId);
            }
        };

        // Additional Requirement
        $ctrl.getRequirementsAdditionalQuery = (requirement) => {
            return dataFeedApi.getRequirementsAdditional($stateParams.MappedPolicyId, requirement.Grouping, requirement.Num);
        };

        // Additional Funding
        $ctrl.getFundingsAdditionalQuery = (funding) => {
            return dataFeedApi.getFundingsAdditional($stateParams.MappedPolicyId, funding.Grouping, funding.Num);
        };

        // Additional Service Feature
        $ctrl.getServiceFeaturesAdditionalQuery = (serviceFeature) => {
            return dataFeedApi.getServiceFeaturesAdditional($stateParams.MappedPolicyId, serviceFeature.Grouping, serviceFeature.Num);
        };

        // Additional Fund Allocations
        $ctrl.getFundAllocationsAdditionalQuery = (fundAllocation) => {
            return dataFeedApi.getFundAllocationsAdditional($stateParams.MappedPolicyId, fundAllocation.Grouping, fundAllocation.Num);
        };

        // Additional Financial Transactions
        $ctrl.getFinancialTransactionsAdditionalQuery = (financialTransaction) => {
            return dataFeedApi.getFinancialTransactionsAdditional($stateParams.MappedPolicyId, financialTransaction.Grouping, financialTransaction.Num);
        };
    }
})(window.app, window.FS);
